// Dagelijkse check-in en familiekring (0050, golf 8; docs/onderzoek/golf8-samenwonen-en-ouderen.md
// §3.6). Handgeschreven zoals memorize.ts en gelijk aan de API (apps/api/src/routes/v1/app/
// checkin.ts en circle.ts); openapi.contract.test.ts bewaakt elke aanroep. Alleen de ouderapp en de
// app van de meekijker; de kiosk gebruikt dit nooit. Geen alarmdienst.
const id = (v) => encodeURIComponent(v);
/** ?a=1&b=2 zonder lege waarden (de contracttest haalt `${query(...)}` uit het pad). */
function query(params) {
    const parts = Object.entries(params)
        .filter((e) => e[1] !== undefined)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
    return parts.length > 0 ? `?${parts.join('&')}` : '';
}
export function createHouseInviteClient(t) {
    const post = (path, body = {}) => t.request('POST', path, body);
    return {
        /** Eén step-up voor de hele lijst (e-mailcode); per regel lid + e-mailadres. */
        send: (items) => post('/v1/app/invitations', { items }),
        pending: () => t.request('GET', '/v1/app/invitations'),
        preview: (token) => post('/v1/app/invitations/house/preview', { token }),
        accept: (token) => post('/v1/app/invitations/house/accept', {
            token,
        }),
        acceptNew: (token, password) => post('/v1/app/invitations/house/accept-new', {
            token,
            password,
        }),
    };
}
export function createCareClient(t) {
    const get = (path) => t.request('GET', path);
    const post = (path, body = {}) => t.request('POST', path, body);
    const put = (path, body) => t.request('PUT', path, body);
    const patch = (path, body) => t.request('PATCH', path, body);
    const del = (path) => t.request('DELETE', path);
    return {
        overview: () => get('/v1/app/checkin'),
        saveProfile: (input) => put('/v1/app/checkin/profile', input),
        /** 'Alles goed' (alleen de oudere zelf met een eigen login). */
        checkIn: () => post('/v1/app/checkin', {}),
        ack: (date) => post('/v1/app/checkin/ack', { date }),
        resolve: (date) => post('/v1/app/checkin/resolve', { date }),
        addPause: (from, to) => post('/v1/app/checkin/pauses', { from, to }),
        stopPause: (pauseId) => del(`/v1/app/checkin/pauses/${id(pauseId)}`),
        consentText: (purpose, locale) => get(`/v1/app/checkin/consent-text${query({ purpose, locale })}`),
        consent: (input) => post('/v1/app/checkin/consent', input),
        withdraw: (purpose) => post('/v1/app/checkin/consent/withdraw', { purpose }),
        invite: (input) => post('/v1/app/circle/invite', input),
        resend: (circleId) => post(`/v1/app/circle/${id(circleId)}/resend`, {}),
        updateCircle: (circleId, input) => patch(`/v1/app/circle/${id(circleId)}`, input),
        approve: (circleId, answer, version) => post(`/v1/app/circle/${id(circleId)}/approve`, { answer, version }),
        remove: (circleId) => del(`/v1/app/circle/${id(circleId)}`),
        leave: () => post('/v1/app/circle/leave', {}),
        invitePreview: (token) => post('/v1/app/invitations/circle/preview', { token }),
        acceptInvite: (token) => post('/v1/app/invitations/circle/accept', {
            token,
        }),
        acceptInviteNew: (token, password) => post('/v1/app/invitations/circle/accept-new', {
            token,
            password,
        }),
    };
}
//# sourceMappingURL=care.js.map